import React from "react";
import { User, Phone, Mail } from 'lucide-react';

class ClientData extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            editedClient: null
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.isEditing && !prevProps.isEditing) {
            // Enter edit mode - initialize edited client
            this.setState({
                editedClient: {
                    name: this.props.client.name || '',
                    phone: this.props.client.phone || '',
                    email: this.props.client.email || ''
                }
            });
        } else if (!this.props.isEditing && prevProps.isEditing) {
            // Exit edit mode - clear edited data
            this.setState({ editedClient: null });
        }
    }

    handleFieldChange = (field, value) => {
        this.setState(prev => ({
            editedClient: {
                ...prev.editedClient,
                [field]: value
            }
        }), () => {
            // Notify parent of changes
            if (this.props.onClientChange) {
                this.props.onClientChange(this.state.editedClient);
            }
        });
    }

    render() {
        const client = this.props.client;
        const isEditing = this.props.isEditing;
        const editedClient = this.state.editedClient || client;

        // Note: Assuming we don't have access to activeCalendar here easily without context wrapper,
        // we'll stick to a neutral primary design that fits both, or default to teal.
        const primaryBgClass = "bg-splavma-teal/10";
        const primaryTextClass = "text-splavma-teal";
        const iconBgClass = "bg-splavma-teal/10";
        const iconTextClass = "text-splavma-teal";

        return (
            <div className="bg-white shadow-sm border border-gray-100 p-5 md:p-6 hover:shadow transition-shadow">
                <div className="flex items-center gap-3 mb-6">
                    <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${iconBgClass}`}>
                        <User className={`w-5 h-5 ${iconTextClass}`} />
                    </div>
                    <h3 className={`text-lg font-bold uppercase tracking-wide ${primaryTextClass}`}>Klient</h3>
                </div>

                <div className="space-y-4">
                    {/* Name */}
                    <div className="flex items-start gap-3 group">
                        <div className="w-8 h-8 bg-gray-50 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-gray-100 transition-colors">
                            <User className="w-4 h-4 text-gray-500 group-hover:text-gray-700" />
                        </div>
                        <div className="flex-1 min-w-0">
                            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-0.5">Meno a priezvisko</p>
                            {isEditing ? (
                                <input
                                    type="text"
                                    value={editedClient.name}
                                    onChange={(e) => this.handleFieldChange('name', e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-200 rounded-xl focus:ring-2 focus:ring-splavma-teal/50 focus:border-splavma-teal transition-all outline-none font-medium"
                                    placeholder="Meno klienta"
                                />
                            ) : (
                                <p className="text-base font-bold text-gray-900 truncate">{client.name || '-'}</p>
                            )}
                        </div>
                    </div>

                    {/* Phone */}
                    <div className="flex items-start gap-3 group">
                        <div className="w-8 h-8 bg-gray-50 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-gray-100 transition-colors">
                            <Phone className="w-4 h-4 text-gray-500 group-hover:text-gray-700" />
                        </div>
                        <div className="flex-1 min-w-0">
                            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-0.5">Telefón</p>
                            {isEditing ? (
                                <input
                                    type="tel"
                                    value={editedClient.phone}
                                    onChange={(e) => this.handleFieldChange('phone', e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-200 rounded-xl focus:ring-2 focus:ring-splavma-teal/50 focus:border-splavma-teal transition-all outline-none font-medium"
                                    placeholder="+421 xxx xxx xxx"
                                />
                            ) : (
                                <a
                                    href={`tel:${client.phone}`}
                                    className="text-base font-bold text-gray-900 hover:text-splavma-teal hover:underline truncate block transition-colors"
                                >
                                    {client.phone || '-'}
                                </a>
                            )}
                        </div>
                    </div>

                    {/* Email */}
                    <div className="flex items-start gap-3 group">
                        <div className="w-8 h-8 bg-gray-50 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-gray-100 transition-colors">
                            <Mail className="w-4 h-4 text-gray-500 group-hover:text-gray-700" />
                        </div>
                        <div className="flex-1 min-w-0">
                            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-0.5">E-mail</p>
                            {isEditing ? (
                                <input
                                    type="email"
                                    value={editedClient.email}
                                    onChange={(e) => this.handleFieldChange('email', e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-200 rounded-xl focus:ring-2 focus:ring-splavma-teal/50 focus:border-splavma-teal transition-all outline-none font-medium"
                                    placeholder="email@example.com"
                                />
                            ) : (
                                <a
                                    href={`mailto:${client.email}`}
                                    className="text-base font-bold text-gray-900 hover:text-splavma-teal hover:underline truncate block transition-colors"
                                >
                                    {client.email || '-'}
                                </a>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ClientData;
